import BasicRouterView from "../../components/BasicRouterView.vue";

const simplificadoRoutes = {
  path: "spf",

  name: "simplificado",
  meta: {
    label: "Simplificado",
    icon: "pinch",
    show: true,
    tabsShow: false,
    direct: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "simplificado/opcoes",
      name: "spf-inicial",
      meta: {
        label: "Inicial",
        icon: "find_in_page",
        show: false,
        simpleShow: false,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/RotaInicial.vue"),
    },

    {
      path: "simplificado/user",
      name: "spf-user",
      meta: {
        label: "Usuários",
        icon: "person",
        show: false,
        simpleShow: true,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "././views/Usuario.vue"),
    },
    {
      path: "simplificado/nova-retirada",
      name: "spf-retirada",
      meta: {
        label: "Retirada de Materiais",
        icon: "shopping_cart",
        show: false,
        simpleShow: true,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/RetiradaMaterial.vue"),
    },
    {
      path: "simplificado/nova-retirada-exporadica",
      name: "spf-retirada-exporadica",
      meta: {
        label: "Retirada Esporádica",
        icon: "shopping_cart_checkout",
        show: false,
        simpleShow: true,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/RetiradaExporadica.vue"),
    },
    {
      path: "simplificado/listagem-materiais",
      name: "spf-materiais",
      meta: {
        label: "Listagem de Requisições",
        icon: "receipt_long",
        show: false,
        simpleShow: true,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "../requisicao/views/Listar.vue"),
    },
    {
      path: "simplificado/status-troca",
      name: "spf-status",
      meta: {
        label: "Consultar Status",
        icon: "add_task",
        show: false,
        simpleShow: true,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/StatusTroca"),
    },
    {
      path: "simplificado/user-cadastrar",
      name: "spf-user-cadastrar",
      meta: {
        label: "Usuários",
        icon: "person",
        show: false,
        simpleShow: false,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/UsuarioCadastrar.vue"),
    },
  ],
};

export default simplificadoRoutes;
